// @flow
import { APICore } from './apiCore';
import config from '../../config';

const api = new APICore();

/**
 * Create a new account
 * @param {*} params
 * @returns
 */
function createAccount(params: any): any {
    const baseUrl = `${config.server.api}/v1/accounts`;
    return api.create(`${baseUrl}`, params);
}

/**
 * Get a new account
 * @param {*} params
 * @returns
 */
function getAccount(params: any): any {
    const id = params.id;
    const baseUrl = `${config.server.api}/v1/accounts`;
    return api.get(`${baseUrl}`, id);
}

/**
 * Get a new account
 * @param {*} params
 * @returns
 */
function getUserAccounts(params: any): any {
    const baseUrl = `${config.server.api}/v1/users/${params.user}/accounts`;
    return api.get(`${baseUrl}`);
}

/**
 * Get a new account
 * @param {*} params
 * @returns
 */
function getOrganizationAccounts(params: any): any {
    const baseUrl = `${config.server.api}/v1/organizations/${params.organization}/accounts`;
    return api.get(`${baseUrl}`, params);
}

/**
 * Get a new account
 * @param {*} params
 * @returns
 */
function updateAccount(params: any): any {
    const id = params.id;
    const body = params;
    const baseUrl = `${config.server.api}/v1/accounts`;
    return api.updatePatch(`${baseUrl}`, id, params);
}

/**
 * Get a new account
 * @param {*} params
 * @returns
 */
function deleteAccount(params: any): any {
    const id = params.id.id;
    const baseUrl = `${config.server.api}/v1/accounts/${id}`;
    console.log(baseUrl)
    return api.delete(`${baseUrl}`);
}

/**
 * Send account email
 * @param {*} params
 * @returns
 */
function sendEmailAccount(params: any): any {
    const id = params.id;
    const isArchived = true;
    const baseUrl = `${config.server.api}/v1/accounts`;
    return api.updatePatch(`${baseUrl}`, id);
}

export { createAccount, getAccount, updateAccount, getUserAccounts, getOrganizationAccounts, deleteAccount, sendEmailAccount };
